import cloneDeep from 'lodash.clonedeep';
import set from 'lodash.set';

import types from './constants';
import { states } from '../../values/enums';
import reportReducers from '../reducers';

const defaultReducer = (state, action) => (state)

const reportPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.PENDING})
  set(next, 'report.data', null)
  return next
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.COMPLETE})
  set(next, 'report.data', action.report)
  return next
}

const reportError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.ERROR, data: action.error})
  return next
}

const actionReducer = Object.assign({
  [types.DIAGNOSTIC_PENDING]: reportPending,
  [types.DIAGNOSTIC_COMPLETE]: reportComplete,
  [types.DIAGNOSTIC_ERROR]: reportError,
}, reportReducers);

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer
  return reducer(state, action)
}

// STATE: {reports: {diagnostic: {
//   selections: {
//     {
//       classroom: {value: label:}
//       metric: {value: label:}
//       level: {value: label:}
//       sort: {value: label:}
//     }
//   },
//   sort: {value: label:}
//   report: {
//     data: 'ref:/_test/data/diagnostic',
//     status: {type: 'PENDING/COMPLETE/ERROR', data: {}}
//   }
// }}}